import oroMxBundledThemeTokens from '../../../public/skins/oro-mx-h5/theme-tokens.json';
import gc987BundledThemeTokens from '../../../public/skins/gc987-h5/theme-tokens.json';
import lorUsBundledThemeTokens from '../../../public/skins/lor-us-h5/theme-tokens.json';
import { activeSkinModule, isGc987Skin, isLorUsSkin, isOroMxSkin } from '@/shared/theme/active-skin';
import { gc987ThemeTokenUrl } from '@/shared/theme/gc987-h5-skin';
import { lorUsThemeTokenUrl } from '@/shared/theme/lor-us-h5-skin';
import { oroMxThemeTokenUrl } from '@/shared/theme/oro-mx-h5-skin';
import { defaultThemeTokens, type ThemeTokenMap } from './theme-tokens';

const BUNDLED_THEME_TOKENS: Record<string, object> = {
  'gc987-h5': gc987BundledThemeTokens,
  'lor-us-h5': lorUsBundledThemeTokens,
  'oro-mx-h5': oroMxBundledThemeTokens,
  ...(activeSkinModule ? { [activeSkinModule.code]: activeSkinModule.bundledThemeTokens } : {}),
};

const BUNDLED_THEME_TOKEN_PATH = /(?:^|\/)skins\/([^/]+)\/theme-tokens\.json(?:[?#].*)?$/i;

export const mergeThemeTokens = (remote: object): ThemeTokenMap => {
  const merged: ThemeTokenMap = { ...defaultThemeTokens };
  for (const [key, value] of Object.entries(remote)) {
    if (typeof value === 'string') {
      merged[key] = value;
    }
  }
  return merged;
};

/** 仓库内已知皮肤 tokens 构建期打进包，避免再回源拉 567B JSON。 */
export const bundledThemeTokensForUrl = (themeTokenUrl: string): ThemeTokenMap | undefined => {
  const path = themeTokenUrl.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/?#]+/i, '');
  const match = path.match(BUNDLED_THEME_TOKEN_PATH);
  if (!match) return undefined;
  const bundled = BUNDLED_THEME_TOKENS[match[1]];
  return bundled ? mergeThemeTokens(bundled) : undefined;
};

const defaultThemeTokenUrl = () => {
  if (activeSkinModule) return activeSkinModule.themeTokenUrl;
  if (isOroMxSkin) return oroMxThemeTokenUrl;
  if (isGc987Skin) return gc987ThemeTokenUrl;
  if (isLorUsSkin) return lorUsThemeTokenUrl;
  return undefined;
};

export const loadThemeTokens = async (themeTokenUrl?: string): Promise<ThemeTokenMap> => {
  const url = themeTokenUrl || defaultThemeTokenUrl();
  if (!url) return defaultThemeTokens;

  const bundled = bundledThemeTokensForUrl(url);
  if (bundled) return bundled;

  try {
    const response = await fetch(url, {
      cache: 'force-cache',
    });

    if (!response.ok) return defaultThemeTokens;

    const remoteTokens = (await response.json()) as object;
    return mergeThemeTokens(remoteTokens);
  } catch {
    return defaultThemeTokens;
  }
};
